import request from '@/utils/request'

/**
 * 获取船舶通行密度热力图数据
 * @param {Object} params 查询参数
 * @param {number} params.minLon 最小经度
 * @param {number} params.minLat 最小纬度
 * @param {number} params.maxLon 最大经度
 * @param {number} params.maxLat 最大纬度
 * @param {string} params.startTime 开始时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.endTime 结束时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {number} [params.gridSize=0.001] 网格大小（度）
 * @param {number} [params.batchDays=7] 每批查询天数
 * @returns {Promise<{code: number, message: string, data: Array<{longitude: number, latitude: number, count: number}>}>}
 */
export function getVesselDensity(params) {
  return request({
    url: '/heatmap/vessel-density',
    method: 'get',
    params,
    // 大时间/大范围查询在数据库繁忙时可能耗时较长，超时放宽至 200s（网关侧同为长超时）
    timeout: 200000
  })
}

/**
 * 获取船舶轨迹线数据（逐船简化轨迹，用于"轨迹线热力图"）
 * @param {Object} params 查询参数
 * @param {number} params.minLon 最小经度
 * @param {number} params.minLat 最小纬度
 * @param {number} params.maxLon 最大经度
 * @param {number} params.maxLat 最大纬度
 * @param {string} params.startTime 开始时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.endTime 结束时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {number} [params.tolerance=0.0002] 轨迹简化容差（度），越大越精简
 * @param {number} [params.maxTracks=3000] 最多返回轨迹条数
 * @param {number} [params.maxPoints=150000] 最多返回顶点总数
 * @returns {Promise<{code: number, message: string, data: Array<{mmsi: string, coords: Array<[number, number]>}>}>}
 */
export function getVesselTracks(params) {
  return request({
    url: '/heatmap/vessel-tracks',
    method: 'get',
    params,
    timeout: 200000
  })
}
